/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse2003OffersModalities
 */
export interface InlineResponse2003OffersModalities {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003OffersModalities
     */
    normal?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003OffersModalities
     */
    fct?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003OffersModalities
     */
    dual?: number;
}

export function InlineResponse2003OffersModalitiesFromJSON(json: any): InlineResponse2003OffersModalities {
    return InlineResponse2003OffersModalitiesFromJSONTyped(json, false);
}

export function InlineResponse2003OffersModalitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2003OffersModalities {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'normal': !exists(json, 'normal') ? undefined : json['normal'],
        'fct': !exists(json, 'fct') ? undefined : json['fct'],
        'dual': !exists(json, 'dual') ? undefined : json['dual'],
    };
}

export function InlineResponse2003OffersModalitiesToJSON(value?: InlineResponse2003OffersModalities | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'normal': value.normal,
        'fct': value.fct,
        'dual': value.dual,
    };
}


